import { Grid, Button, Typography, Box } from '@mui/material';
import { BottomDrawer } from '@care/react-component-lib';
import { DrawerMemberSelectionCoreProps } from '@/types';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import { AnalyticsEventName, CtaLocation, CtaText, ScreenName } from '@/types/enums';
import { LAYOUTS } from '@/constants';

function GreaterCareDrawerMemberSelection({
  handleSeeker,
  handleSitter,
  isBottomDrawerOpen,
  modalButtonsText,
  selectedVerticalIcon,
  setIsBottomDrawerOpen,
}: DrawerMemberSelectionCoreProps) {
  return (
    <BottomDrawer
      open={isBottomDrawerOpen}
      onClose={() => {
        AnalyticsHelper.logEvent({
          name: AnalyticsEventName.CTA_INTERACTED,
          data: {
            cta_intent: 'Dismiss modal',
            cta_text: CtaText.CLOSE_MODAL,
            cta_location: CtaLocation.VHP_MODAL,
            screen_name: ScreenName.VISITOR_HOMEPAGE,
            enrollment_initiated: false,
          },
        });
        setIsBottomDrawerOpen(false);
      }}>
      <Box textAlign="center" width="auto" data-testid={`${LAYOUTS.greaterCare}-for-bottom-drawer`}>
        <Box marginBottom="16px">{selectedVerticalIcon}</Box>
        <Typography variant="h2">I would like to:</Typography>
        <Grid
          container
          justifyContent="space-between"
          direction="row"
          maxWidth="336px"
          marginX="auto"
          sx={() => ({
            pb: '40px',
            pt: '24px',
            '& button': {
              width: '160px',
            },
          })}>
          <Button
            color="primary"
            variant="contained"
            size="medium"
            data-testid="findACaregiver"
            onClick={handleSeeker}>
            {modalButtonsText.seeker}
          </Button>
          <Button
            color="primary"
            variant="contained"
            size="medium"
            data-testid="findAJob"
            onClick={handleSitter}>
            {modalButtonsText.provider}
          </Button>
        </Grid>
      </Box>
    </BottomDrawer>
  );
}

export default GreaterCareDrawerMemberSelection;
